export default __webpack_public_path__ + "static/Tek_Replicator-940a663b82c8cdd2e70227383b32f6b6.png";